// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"0":"vendors","10":"main"}[chunkId] + "." + {"0":"59dc018e192e2e8a2ef6","10":"565d2440ecc05e44933f"}[chunkId] + ".min.css";
};